import React from 'react';
import { Construction } from 'lucide-react';

const PlaceholderPage = ({ title, subtitle }) => (
  <div className="min-h-[60vh] flex items-center justify-center px-4">
    <div className="text-center max-w-md">
      <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-[#1a1417] border border-[#2a1f24] flex items-center justify-center">
        <Construction className="w-7 h-7 text-[#c19a8a]" />
      </div>
      <h1 className="font-serif text-3xl text-white mb-2">{title}</h1>
      <p className="text-[#9a8a83]">{subtitle}</p>
    </div>
  </div>
);

export default PlaceholderPage;
